import React from 'react'
import Header from './components/Header/Header'
import Nav from './components/Nav/Nav'
import About from './components/About/About'
import Experience from './components/Experince/Experience'
import Service from './components/Services/Services'
import Portfolio from './components/Portfolio/Portfolio'
import Testimonials from './components/Testimonials/Testimonials'
import Contact from './components/Contact/Contact'
import Footer from './components/Footer/Footer'
import { Analytics } from '@vercel/analytics/react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
const App = () => {
  return (
<>
<Nav/>
<Header/>
<About/>
<Experience/>
<Service/>
<Portfolio/>
<Testimonials/>
<Contact/>
<Analytics/>
<ToastContainer position="bottom-right" autoClose={2500} closeOnClick pauseOnHover theme="dark" />
<Footer/>

</>
  )
}

export default App